/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Button, Form, Row, Col, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import store from 'features/store';
import { REFRESH_TOKEN, isTokenExpiredBeforeOneHour, getToken } from 'shared/settings/token';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import { categorynewlist, itemclone, itemlist, salelist, statelist, citylist, itemimagelist, itemdelete,saledetail,createdbyList, itemsNoteCount, locationlist } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import Notes from './Notes';
import { Link } from 'react-router-dom';

// style imports
import './ItemsList.scss';
import { ArrayValueReorder } from 'shared/modifiers';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to show items as list
 * 
 * @param props
 * 
 * @return  items list html code
 * 
**/

export class ItemsList extends Component {
    initialSearchState;
    config;
    category;
    id;
    itemType = { 'Onsite': 'onsite.svg', 'Direct buy': 'direct.svg', 'Auction': 'bid.svg' };
    stateList;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.initialSearchState = {
            categoryid: { field: 'category', value: '', op: '=', join: 'AND' },
            title: { field: 'title', value: '', op: 'LIKE', join: 'AND' },
            description: { field: 'description', value: '', op: 'LIKE', join: 'AND' },
            starttime: { field: 'createddate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'createddate', value: '', op: '<=', join: 'AND' },
            SKU: { field: 'SKU', value: '', op: 'LIKE', join: 'AND' },
            createdby: { field: 'createdby', value: '', op: 'LIKE', join: 'AND' },
            itemstatus: { field: 'itemstatus', value: '', op: 'LIKE', join: 'AND' },
            state: { field: 'state', value: '', op: 'LIKE', join: 'AND' },
            city: { field: 'city', value: '', op: 'LIKE', join: 'AND' },
            zipcode: { field: 'zipcode', value: '', op: 'LIKE', join: 'AND' },
            saletitle: { field: 'saletitle', value: '', op: 'LIKE', join: 'AND' },
            boughtby: { field: 'boughtby', value: '', op: 'LIKE', join: 'AND' },
            saleid: { field: 'saleid', value: this.props.location.state && this.props.location.state.saletitle ? this.props.match.params.saleId : this.props.match.params.saleId, op: 'LIKE', join: 'AND' },
            isDeleted: {field: 'isDeleted', value: 1, op: '!=', join: 'AND'},
            categoryGroup : { field: 'categoryGroup', value: '', op: '=', join: 'AND' },
            locationid: { field: 'locationid', value:  this.props?.location?.state?.locationid ?  this.props.location?.state.locationid : '' , op: '=', join: 'AND' },
        }
        this.cloneModalConfig = {
            header: 'Cloning',
            label: 0
        }
        const searchState = JSON.parse(JSON.stringify(this.initialSearchState));
        // searchState.starttime.value = this.props.match.params.saleId !== undefined && !isNaN(Number(this.props.match.params.saleId))  ? '' : new Date();
        this.state = {
            locations: [],
            search: searchState,
            filterSearch: searchState,
            searchData: false,
            issearch: false,
            category: [],
            createdBy: [],
            showCloneModal: false,
            salesList: [],
            singleItemSalesList: [],
            singleItemLength: 0,
            tempSalesList: [],
            selectedSalesLength: 0,
            cloneProcess: false,
            cloneModalConfig: this.cloneModalConfig,
            itemsList: [],
            enableCloneButton: false,
            enableGroupCloneButton: false,
            tableData: [],
            itemsDetails: {},
            cloneStatus: { show: false, type: '', message: '' },
            deleteStatus: { show: false, type: '', message: '' },
            stateList: [],
            cityList: [],
            imageList: [],
            displayImage: {},
            salefrom : false,
            deleteModal:false,
            deleteLoading:false,
            deleteItemids:[],
            Local_saleid: '',
            Local_saletitle: '',
            Local_salestatus: false,
            PageSize: 10,
            notesCount: [],
            categoryMenuName: '',
            errorPageRedirect: false,
            errorType: '',
            locationErrorMsg: '',
        }

        this.config = {
            name: 'item',
            url: '',
            createurl: '/sales/item/create',
            search: { prevPath: this.props.location.pathname },
            params: {},
            columns: [
                { name: '', property: '', width: '50px', columnType: 'custom', customColumn: (event) => this.checkBox(event), customHeader: 'selectAll' },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['notes', 'clone', 'edit'], customHeader: <><div><Button disabled={this.props.location.state !== undefined && this.props.location.state.isClosed} className="save-button" style={{ marginLeft: "10%" }} onClick={() => this.navigateToEdit()}>+ Create</Button></div></>, width: '100px',
                    actionEvents: {
                        notes: (id) => { this.viewNotes(id) }, clone: (row) => { this.singleItemSelect(row) },
                        actionEnableOn: { edit: (row) => this.editAction(row) },
                        edit: (row, state) => {
                            this.props.history.push({
                                pathname: `/sales/items/edit/${row['id']}`,
                                state: {
                                    prevPath: this.props.history.location.pathname,
                                    PageSize: this.state.PageSize,
                                    saletitle: this.props.location.state && this.props.location.state.saletitle ? this.props.location.state.saletitle : '',
                                    ...state,
                                    prevDatatable: this.props.location.state !== undefined ?
                                        this.props.location.state.prevDatatable === undefined ?
                                            this.props.location.state.datatable
                                            : this.props.location.state.prevDatatable
                                        : undefined
                                }
                            })
                        }
                    },
                    accordion: this.accordionValue,
                },
                { name: 'Title', property: 'title', sort: true, width: '210px' },
                { name: 'Sale', property: 'saletitle', sort: true, width: '200px' },
                { name: 'Type', property: 'itemtypename', sort: false, width: '100px', columnType: 'custom', customColumn: this.customType, class: "remove-text-wrap" },
                { name: 'SKU', property: 'SKU', sort: true, width: '150px' },
                { name: 'Status', property: 'itemstatus', sort: false, width: '100px' },
                {
                    name: '', property: 'id', columnType: 'actions', actions: [''], customHeader: "CSV", width: '200px',
                },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: <></>, width: '25px',
                    accordion: this.accordionValue,
                }
                
            ],
            sort: [
                {
                    "field": "modifieddate",
                    "direction": "desc"
                }],
            pagination: true,
            extraButton: this.groupCloneButton,
            field: ['itemviewurl', 'isDeleted', 'id', 'SKU', 'itemtypename', 'category', 'title', 'saletitle', 'itemstatus', 'createdby', 'updatedby', 'modifieddate', 'address1', 'address2', 'isfeatured', 'isshippable', 'istaxable', 'startingprice', 'reserveprice', 'buyerspremium', 'tax', 'buynowprice', 'width', 'height', 'length', 'weight', 'handlingfee','soldprice', 'shippingfee', 'itemtypeid', 'itemtypename', 'contact', 'contactemail', 'contactmobile', 'locationtitle', 'locationid', 'saleid','createddate','description','itemsoldprice'],
            // conditionKey :["itemtypename","Direct buy"]
            notesGreenCircle: (data) => this.notesGreenCircle(data),
            filename: "item-report",
            csvColumn: [
                { name: 'Item', property: 'title',columnType: 'custom', customColumn: (row) => { if ('title' in row) return (this.customAddQuotes(row.title)) } },
                { name: 'Sale', property: 'saletitle', columnType: 'custom', customColumn: (row) => { if ('saletitle' in row) return (this.customAddQuotes(row.saletitle)) } },
                { name: 'Type', property: 'itemtypename', columnType: 'custom', customColumn: (row) => { if ('itemtypename' in row) return (this.customAddQuotes(row.itemtypename)) } },
                { name: 'SKU', property: 'SKU'},
                { name: 'Status', property: 'itemstatus' },
                { name: 'Contact', property: 'contactemail' },
                { name: 'Shipping', property: 'isshippable', columnType: 'custom', customColumn: (row) => { if ('isshippable' in row && row.isshippable == '1') {return 'Yes'} else {return 'No'} }},
                { name: 'Pricing', property: 'buynowprice', columnType: 'custom', customColumn: this.customPricing },
                { name: 'Category', property: 'category' },
                { name: 'Location', property: 'locationtitle' },
                { name: 'Address', property: 'address', columnType: 'custom', customColumn : this.customAddress  },
                { name: 'Created By', property: 'createdby' },
                { name: 'Created Date', property: 'createddate', columnType: 'custom', customColumn: this.customCreatedDate },
                { name: 'Updated By', property: 'updatedby' },
                { name: 'Last Modified', property: 'modifieddate', columnType: 'custom', customColumn: this.customLastModified },
                { name: 'Taxable', property: 'istaxable', columnType: 'custom', customColumn: (row) => { if ('istaxable' in row && row.istaxable == '1') {return 'Yes'} else {return 'No'} }},
                { name: 'Description', property: 'description', columnType: 'custom', customColumn : this.customDescription },
                { name: 'Featured', property: 'isfeatured', columnType: 'custom', customColumn: (row) => { if ('isfeatured' in row && row.isfeatured == '1') {return 'Yes'} else {return 'No'} }},
                { name: 'Item URL', property: 'itemviewurl', columnType: 'custom', customColumn : this.customURL },
            ]
        };
        // if (this.props.location.state && this.props.location.state.prevPath)
        //     this.setSearchSale();
        // else {
        //     this.config['url'] = itemlist;
        //     this.setSearchSale();
        // }
        this.id = null;
        this.cloneForm = {
            sale: [],
            itemsList: [],
            singleItem: [],
            clonemedia: false
        };
        this.stateList = [];

        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search && !this.props.location.state.prevPath) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === 'modifieddate' || temp['field'] === 'starttime' ||  temp['field'] === 'endtime') {
                    temp['value'] = new Date(temp['value']);
                }
                if (temp['field'] === 'modifieddate' && temp['op'] === '<=') {
                    temp['field'] = 'endtime';
                }
                if (temp['field'] === 'modifieddate' && temp['op'] === '>=') {
                    temp['field'] = 'starttime';
                }
                if(temp['field'] === 'category' && temp['op'] === '='){
                    tempSearch['categoryid'] = temp;
                }
                if (temp['field'] === 'createddate') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                    temp['value'] = new Date(temp['value']);
                    if (temp['op'] === '>=') {
                        tempSearch['starttime'] = temp;
                    } else if (temp['op'] === '<=') {
                        tempSearch['endtime'] = temp;
                    }
                } else {
                    tempSearch[temp['field']] = temp;
                }
                
            });

            this.state['search'] = tempSearch;
            this.state['filterSearch'] = search;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
            if (this.state['search']['state'].value)
                this.getCity();
            // this.enableSearch();    
        }
        if (this.props.location.state && this.props.location.state.createSearch) {
            this.state['searchData'] = true;
            this.enableSearch();
        }
        if(this.props?.location?.itemEdit === false){
            this.config['url'] = itemlist;
        }
        else {
            if (this.props.match.params.saleId || this.props.location.state) {
                this.setSearchSale()
            }
        }
    }

    groupCloneButton = () => {
        return (
            <Button size="sm" className="mx-6" variant="secondary" onClick={() => this.groupClone(true)} disabled={!this.state.enableGroupCloneButton}>Group Cloning</Button>
        );
    }

    customTitleColumn = (values) => {
        return (
            <div className="text-handling">
                {values['title']}
            </div>
        );
    }
    customSaleTitleColumn = (values) => {
        return (
            <div className="text-handling">{values['saletitle']}</div>
        );
    }

    editAction = (values) => {
        return values['itemstatus'].toLowerCase() !== 'sold' && values['itemstatus'].toLowerCase() !== 'not sold';
    };

    customPricing = (values) => {
        if(values['buynowprice'] && values['itemstatus'] === 'Sold' && values['itemtypename'] === "Direct buy"){
            return values['buynowprice']
        }
        else if(values['itemstatus'] === 'Sold' && values['soldprice']){
            return values['soldprice']
        }
        else{
            return 0
        }
    }
    

    /* CustomType for item */
    customAddQuotes = (values) => {
        return values?.replace(/"/g, '""')
    }

    /* Custom Modified Date */
    customLastModified = (values) => {
        if (values['modifieddate'] != null) {
            let newdate = moment.tz(values['modifieddate'], values['modifieddate']).local();
            return `${newdate.format('MM/DD/YYYY hh:mm:ss A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }

    /* Custom Created Date */
    customCreatedDate = (values) => {
        if (values['createddate'] != null) {
            let newdate = moment.tz(values['createddate'], values['createddate']).local();
            return `${newdate.format('MM/DD/YYYY hh:mm:ss A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }

    /* Custom Address */
    customAddress = (values) => {
        if (values.address2 && values.address2){
            const res = values.address1 +', ' + values.address2 ;
            return res;
        }
        else {
            const res = values.address1 ;
            return res;
        }
    }

    customURL = (values) => {
        if (values.itemviewurl != null) {
            const res = values?.itemviewurl 
            return res; 
        }
    }
    
    // custom Description to remove tags
    customDescription = (values) => {
        let content = values.description
        content = content ? content : ''
        let removeTag = content.replace(/<(.|\n)*?>/g, '');;
        return removeTag;
    }

    /* custom type for item */
    customType = (values) => {
        if (values['itemtypename'])
            return <div className="itemtype"><img src={`${process.env.PUBLIC_URL}/static/icons/table/${this.itemType[values['itemtypename']]}`} alt={values['itemtypename']} height="35px" width="35px" onClick={(event) => { event.stopPropagation(); }} /><span className="itemtypetooltip">{values['itemtypename']}</span></div>;
        else
            return '- - -';
    }
    /* called when create clicked */
    navigateToEdit = async () => {

        if (!isTokenExpiredBeforeOneHour(REFRESH_TOKEN)) {
            let data = {};
            data['datatable'] = this.state.tableData.stateData;
            this.props.history.push({
                pathname: '/sales/item/create',
                state: {
                    prevPath: this.props.history.location.pathname,
                    PageSize: this.state.PageSize,
                    saletitle: this.props.location.state && this.props.location.state.saletitle ? this.props.location.state.saletitle : '',
                    ...data,
                    prevDatatable: this.props.location.state !== undefined ?
                        this.props.location.state.prevDatatable === undefined ?
                            this.props.location.state.datatable
                            : this.props.location.state.prevDatatable
                        : undefined
                }
            })
        } else {
            if (getToken(REFRESH_TOKEN)) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
            }
        }
    }
    componentDidMount() {
        if(this.props.match.params.saleId){
            this.getSaleDetail();
        }else{
            this.getLocationList()
        }
        
        if(this.props.location.state?.state?.name === "SaleList")
        {
            this.setState({
                salefrom: true
            })
        }
        if (this.props.location.state && this.props.location.state.createSearch) {
            this.setState({
                search: {
                    ...this.state.search,
                    starttime: {
                        ...this.state.search.starttime,
                        value: ''
                    }
                }
            })
        }
        this.getCategoryList();
        this.getSalesList();
        // this.getItemList();
        this.getCreatedByList();
        this.getStateList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);

        // Handle Pagination Previous selected dropdown
        if(this.props?.location?.state){
            if(this.props?.location?.state?.PageSize){
                this.setState({
                    PageSize: this.props?.location?.state?.PageSize
                })  
            }
            else{
                this.setState({
                    PageSize: 10
                })
            }
        }
        else{
            if(this.props.match.params.saleId){
                this.setSearchSale()
            }
            this.setState({
                PageSize: 10
            })
        }
    }
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                let locationErrorMsg = !this.props?.location?.state?.datatable?.search  ?  'Location is required. Please select the location and at least one additional field to continue.' : ''
                this.locations = response[0].data.data;
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        isdisabled: true,
                        locationErrorMsg,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        locationErrorMsg
                    })
                }
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.state.salefrom) {
            this.navigateToList()
        }
        else {
            window.history.pushState(null, null, window.location.pathname);
        }

    }

    getCreatedByList = () => {
        axios.get(getSellerUrl(createdbyList), getSellerHeaders())
        .then(response => {
            if (response.status === 200) {
                if(response.data.data.length > 0) {
                    const createdBy = response.data.data.map(item => item.ITEM_CreatedBy)
                    this.setState({
                       ...this.state,
                          createdBy,
                     });
                }
            }
        })
        .catch(error => {
            if(error.response?.status == 401 || error.response?.status == 404) {
                this.setState({
                    errorPageRedirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        });

    }
    // to get Sale details
    getSaleDetail = () => {
        let field = ['id', 'title', 'status', 'invoicegenerated', 'locationid', 'locationtitle', 'endtime', 'timezonename', 'itemcount'];
        axios.post(getSellerUrl(`${saledetail}/${this.props.match.params.saleId}`), JSON.stringify({ field: field }), getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.length == 0) {
                        this.setState({
                            errorPageRedirect: true,
                            errorType: "noData"
                        })
                        return;
                    }
                    response = response.data.data[0];
                    this.setState({
                        locations: ArrayValueReorder({id: response.locationid, title:  response.locationtitle}, 'title'),
                        Local_saleid: response.id,
                        Local_saletitle: response.title,
                        Local_salestatus: response.status === 'Closed',
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: response.locationid
                            },
                        }
                    })
                }
            })
            .catch((error) => {
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorPageRedirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }  
            });

    };

    /*get item list for sale id */
    setSearchSale = () => {
        setTimeout(() => {
            this.config['url'] = itemlist;
            this.setState({
                ...this.state,
                // filterSearch: [
                //     { field: 'saleid', value: this.props.match.params.saleId ? this.props.match.params.saleId : this.state.Local_saleid , op: 'LIKE', join: 'AND' },
                //     { field: 'isDeleted', value: 1, op: '!=', join: 'AND'}
                // ],
                searchData: true
            }, () => {
                    this.dataTable.current.searchData();
                    setTimeout(() => {
                        this.setState({ searchData: false })
                    }, 5000);
            });
        })

    }

    /* Get category list */
    getCategoryList = () => {
        axios.get(getSellerUrl(categorynewlist), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    let category = response.data.data.data[0]
                    Object.values(category).map((item) => {
                        return item.sort()
                    })
                    this.setState({
                        ...this.state,
                        category,
                    });
                }
            })
            .catch(error => {
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorPageRedirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
                this.setState({
                    cloneStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }
    /* Get state list */
    getStateList = () => {
        axios.get(getSellerUrl(statelist), getSellerHeaders())
            .then(response => {
                this.stateList = ArrayValueReorder(response.data.data, 'state');
                this.setState({ stateList: this.stateList });
            })
            .catch(error => {
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorPageRedirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    /* get city list */
    getCity = () => {
        let cityList = [];
        if (this.state.search.state.value) {
            axios.get(getSellerUrl(`${citylist}/${this.state.search.state.value}`), getSellerHeaders())
                .then(response => {
                    cityList = ArrayValueReorder(response.data.data, 'city');
                    cityList = cityList.filter((city, index) => {
                        const _city = JSON.stringify(city);
                        return index === cityList.findIndex(obj => {
                            return JSON.stringify(obj) === _city;
                        });
                    });
                    this.setState({
                        cityList: cityList,
                        search: {
                            ...this.state.search,
                            // city: {
                            //     ...this.state.search.city,
                            //     value: ''
                            // }
                        }
                    });
                })
                .catch(error => {
                });
        }
    }

    /* get created by for item list */
    getItemList = () => {
        const data = {
            field: ['id','createdby', 'saleid'],
        };
        if(this.props.match.params.saleId && !isNaN(Number(this.props.match.params.saleId))){
            data['filter'] = [{ field: 'saleid', value: this.props.match.params.saleId, op: '=', join: 'AND' }];
        } else {
            data['filter'] = [{ field: 'id', value: '1', op: '>=', join: 'AND' }];
        }
        axios.post(getSellerUrl(itemlist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    // let createdBy = response.data.data.map(item => item.createdby)
                    // createdBy = [...new Set(createdBy)]
                    // this.setState({
                    //     createdBy
                    // })
                    // this.setState({
                    //     ...this.state,
                    //     createdBy: response.data.data
                    // }, () => {
                    //     /* remove duplicates in created by */
                    //     var obj = {};
                    //     for (var i = 0, len = this.state.createdBy.length; i < len; i++) {
                    //         if (!obj[this.state.createdBy[i]['createdby']]) obj[this.state.createdBy[i]['createdby']] = this.state.createdBy[i];
                    //     }
                    //     var newArr = [];
                    //     for (var key in obj) newArr.push(obj[key]);
                    //     newArr = ArrayValueReorder(newArr, 'createdby');
                    //     this.setState({
                    //         ...this.state,
                    //         createdBy: newArr
                    //     });

                    // });
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                // this.setState({
                //     cloneStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                // });
            });
    }

    /* custom checkbox*/
    checkBox = (value) => {
        return (
            <div className="custom-header-checkbox">
                <Form>
                    {/* <Form.Check type="checkbox" label="" value={value.id} onChange={(event) => { event.stopPropagation(); this.selectItems(event, value) }} /> */}
                    <div className={`custom-checkbox-div ${this.checkBoxChecked(value.id) ? 'checked' : ''}`} onClick={(event) => { event.stopPropagation(); this.selectItems(event, value) }}></div>
                </Form>
            </div>
        );
    }


    /* called when note clicked */
    viewNotes = (id) => {
        const data = this.state.tableData.data.filter(x => x.id === id);
        this.setState({
            ...this.state,
            modal: true,
            itemsDetails: data[0]
        });
        this.id = id;
    }

    /* called when save or note closed */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        })
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let categoryName = '';
        this.setState((prevState) => ({
            issearch: true,
            search: {
                ...prevState.search,
                [event.target.name]: {
                    ...prevState.search[event.target.name],
                    value: event.target.value.trimStart()
                }
            }
        }), () => {
            if (event.target.value === '') {
                this.checkSearch();
                this.setState({
                    // search: {
                    //     ...this.state.search,
                    //     city: {
                    //         ...this.state.search.city,
                    //         value: ''
                    //     }
                    // }
                });
            }
            if (event.target.name === 'categoryid' && typeof event?.target?.selectedIndex === 'number' && event.target.selectedIndex > -1) {
                categoryName = event.target.options[event.target.selectedIndex]?.parentNode?.label;
                this.setState({
                    issearch: true,
                    search: {
                        ...this.state.search,
                        categoryGroup: {
                            ...this.state.search.categoryGroup,
                            value: event.target.value ? categoryName : ''
                        }
                    }
                })
            }
            if (event.target.name === 'state') {
                this.getCity();
            }
            const { search } = this.state;
    
            const locationSelected = !!search.locationid.value;
            const othersEmpty = Object.keys(search)
                .filter(key => key !== "locationid"  && key !== "isDeleted")
                .every(key => !search[key].value);
    
            let errormsg = '';
            if (locationSelected && (othersEmpty )) {
                errormsg = 'Location is required. Please select the location and at least one additional field to continue,'
            }
            
            
            if(locationSelected){
                this.setState({ locationErrorMsg: errormsg });
            }
        });

    }

    /* called when clear all clicked will reset state to initial */
    resetState = () => {
        this.setState({
            ...this.state,
            errorMessage: '',
            locationErrorMsg:  !this.props?.location?.state?.locationid && 'Location is required. Please select the location and at least one additional field to continue.',
            search: this.initialSearchState,
            filterSearch: this.initialSearchState,
            searchData: this.props.location.state && this.props.location.state.saletitle ? true : false,
            issearch: false,

        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        let filter = {};
        filter = {
            categoryid: { ...this.state.search.categoryid },
            title: { ...this.state.search.title, value: this.state.search.title.value ? '*' + this.state.search.title.value + '*' : '' },
            description: { ...this.state.search.description, value: this.state.search.description.value ? '*' + this.state.search.description.value + '*' : '' },
            SKU: { ...this.state.search.SKU, value: this.state.search.SKU.value ? '*' + this.state.search.SKU.value + '*' : '' },
            starttime: { ...this.state.search.starttime, value: this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            createdby: { ...this.state.search.createdby },
            itemstatus: { ...this.state.search.itemstatus },
            state: { ...this.state.search.state },
            city: { ...this.state.search.city },
            zipcode: { ...this.state.search.zipcode },
            saletitle: { ...this.state.search.saletitle, value: this.state.search.saletitle.value ? '*' + this.state.search.saletitle.value + '*' : '' },
            boughtby: { ...this.state.search.boughtby, value: this.state.search.boughtby.value ? '*' + this.state.search.boughtby.value + '*' : '' },
            saleid: { ...this.state.search.saleid },
            isDeleted: { field: 'isDeleted', value: 1, op: '!=', join: 'AND' },
            categoryGroup: {...this.state.search.categoryGroup},
            locationid:  { ...this.state.search.locationid },
        }
        this.config['url'] = itemlist;
        this.setState({
            ...this.state,
            filterSearch: filter,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (control !== 'saleid' && this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            filterSearch: isenable ? this.state.filterSearch : this.initialSearchState,
            searchData: isenable ? this.state.searchData : this.props.location.state && this.props.location.state.saletitle && issearchData ? true : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData) {
                this.dataTable.current.searchData();
                setTimeout(() => {
                    this.setState({ searchData: issearchData ? false : this.state.searchData });
                }, 5000);
            }
        });

    }

    /* called when clicking on accordion */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div>
                <div className="accordion-item">
                    {row && Object.keys(row).length ?
                        <div className="d-flex">
                            <div className="mx-2" style={{ width: "calc(100%/7)" }}>
                                <h6>Contact</h6>
                                <div>{row['contact'] ? row['contact'] : ''}</div>
                                <div style={{ wordBreak: "break-word" }}>{row['contactemail'] ? row['contactemail'] : ''}</div>
                                <div>{row['contactmobile'] ? row['contactmobile'] : ''}</div>

                            </div>
                            {row['isshippable'] || row['isfeatured'] || row['istaxable'] || (row['width'] && row['height'] && row['length']) || row['weight'] ?
                                <div className="mx-1" style={{ width: row['width'] && row['height'] && row['length'] ? "calc(100%/5)" : "calc(100%/8)" }}>
                                    <h6>Shipping</h6>
                                    <div>{row['width'] && row['height'] && row['length'] ? row['length']  + '*' +  row['width'] + '*' + row['height']  : ''}</div>
                                    <div>{row['weight'] ? row['weight'] + 'lbs' : ''}</div>
                                    <div>{row['isshippable'] ? '[shippable]' : ''}</div>
                                    <div>{row['isfeatured'] ? '[featured]' : ''}</div>
                                    <div>{row['istaxable'] ? '[taxable]' : ''}</div>
                                    {row['isshippable'] ?
                                        <div>
                                            <div>Shipping: ${+row['shippingfee']}</div>
                                            <div>Handling: ${+row['handlingfee']}</div>
                                        </div> : ''}
                                </div>
                                : ''}
                            <div className="mx-2" style={{ width: "calc(100%/8)" }}>
                                <h6>Pricing</h6>
                                <div>Starting: {row['startingprice'] ? '$' + row['startingprice'].toFixed(2) : '- - -'}</div>
                                <div>Reserve: {row['reserveprice'] ? '$' + row['reserveprice'].toFixed(2) : '- - -'}</div>
                                <div style={{whiteSpace: 'nowrap'}}>Buynow: {row['buynowprice'] ? '$' + row['buynowprice'].toFixed(2) : '- - -'}</div>
                                <div>BP: {row['buyerspremium'] != null ? row['buyerspremium'] + '%' : '- - -'}</div>
                                <div>Tax: {row['tax'] != null ? row['tax'] + '%' : '- - -'}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/8)" }}>
                                <h6>Category</h6>
                                <div>{row['category'] ? row['category'] : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/8)" }}>
                                <h6>Location</h6>
                                <div>{row['locationtitle'] ? row['locationtitle'] : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/8)" }}>
                                <h6>Address</h6>
                                {/* <div>{row['city']},{row['zipcode']}</div> */}
                                <div>{row['address1'] ? row['address1'] : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/8)" }}>
                                <h6>Created By</h6>
                                <div>{row['createdby'] ? row['createdby'] : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/8)" }}>
                                <h6>Created Date</h6>
                                <div>{row['createddate'] ? `${moment.utc(row['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/8" }}>
                                <h6>Updated By</h6>
                                <div>{row['updatedby'] ? row['updatedby'] : ''}</div>
                            </div>
                            <div className="mx-1" style={{ width: "calc(100%/7)" }}>
                                <h6>Last Modified</h6>
                                <div>{row['modifieddate'] ? `${moment.utc(row['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : ''}</div>

                            </div>
                            <div>
                                <h6>Item url</h6>
                                <div><a href={row['itemviewurl'] ? row['itemviewurl'] : ''} target="_blank">{row['itemviewurl']}</a></div>
                            </div>
                        </div>

                        : ''}
                </div>
                {/* <div>
                    <img src={this.state.displayImage.url ? this.state.displayImage.url : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="thumbnail" height="135" width="135"></img>
                </div> */}
            </div>
        );
    }

    /**
     * 
     * @param event {data, index}
     */
    onOpenAccordion = (event) => {
        this.setState({
            imageList: [],
            displayImage: {}
        }, async () => {
            let filter = [{ field: 'itemid', value: event.data.id, op: '=', join: 'AND' }];
            this.setState({ formLoading: true });
            await axios.post(getSellerUrl(itemimagelist), JSON.stringify({ filter: filter }), getSellerHeaders())
                .then(response => {
                    const data = response.data.data;
                    const displayImage = data.filter(x => x.isdisplayimage === 1);
                    const checkValue = displayImage.length > 0 ? displayImage[0] : {};
                    this.setState({
                        imageList: response.data.data,
                        displayImage: checkValue
                    });
                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                });
        });
    }


    /* Called when clone icon click */
    singleItemSelect = (row) => {
        const index = this.cloneForm.singleItem.length;
        let singleItemSalesList = this.state.singleItemSalesList
        if (index === 0) {
            this.cloneForm.singleItem.push(row);
            // singleItemSalesList = this.state.singleItemSalesList.filter(x => x.id !== row.saleid);
        } else {
            this.cloneForm.singleItem[0] = row;
        }
        this.cloneModalConfig.header = 'Cloning';
        this.cloneModalConfig.label = 1;
        this.setState({
            showCloneModal: true,
            cloneModalConfig: this.cloneModalConfig,
            singleItemLength: 1,
            singleItemSalesList
        });
    }

    /* Called when clone modal close button click */
    closeCloneModal = (props, clean = false) => {
        this.cloneForm.sale = [];
        if (this.cloneForm.singleItem.length > 0) {
            this.setState({
                ...this.state,
                singleItemSalesList: JSON.parse(JSON.stringify(this.state.tempSalesList)),
                singleItemLength: 0
            });
            this.cloneForm.singleItem = [];
        }
        if (clean) {
            this.cloneForm.itemsList = [];
            this.setState({
                ...this.state,
                itemsList: [],
                salesList: JSON.parse(JSON.stringify(this.state.tempSalesList)),
                singleItemSalesList: JSON.parse(JSON.stringify(this.state.tempSalesList)),
                singleItemLength: 0
            });
        }
        this.cloneForm.clonemedia = false
        this.setState({ showCloneModal: false, selectedSalesLength: 0, cloneProcess: false ,cloneStatus: { show: false, type: '', message: '' }, enableCloneButton: false });
    }

    /* Called when clone button click */
    cloneCreate = () => {
        this.setState({ cloneProcess: true });

        const items = this.cloneForm.singleItem.length > 0 ? this.cloneForm.singleItem : this.cloneForm.itemsList;
        const final_items = items.map(x => x.id);
        const final = {
            "saleid": parseInt(this.cloneForm.sale),
            "clonemedia": this.cloneForm.clonemedia,
            "itemids": final_items
        };
        axios.post(getSellerUrl(itemclone), JSON.stringify({ data: final }), getSellerHeaders()).then(
            response => {
                if (response.status === 200) {
                    // this.closeCloneModal(true, true);
                    // toast.success('Success');
                    this.setState({
                        cloneProcess: false,
                        cloneStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({ cloneStatus: { show: false, type: '', message: '' }, searchData: true }, () => {
                                this.dataTable.current.searchData();
                                this.closeCloneModal(true, true);
                                this.checkBoxUpdate(false);
                            })
                        }, 3000);
                    });

                } else {
                    this.setState({ cloneProcess: false });
                }
            }
        ).catch(error => {
            // error.response.data['message'] instanceof Array ? toast.error(error.response.data['message'][0]['message']) : toast.error(error.response.data['message']);
            this.setState({
                cloneProcess: false,
                cloneStatus: { show: true, type: 'danger', message: error.response.data['message'] instanceof Array ? error.response.data['message'][0]['message'] : error?.response?.data['message'] }
            });
        });
    }

    /* Get sales list for clone items */
    getSalesList = () => {
        axios.post(getSellerUrl(salelist), JSON.stringify({ filter: [{ field: "status", value: "Closed", op: "!=", join: "AND" }, { field: 'isDeleted', value: 0, op: '=', join: 'AND' }], field: ['id', 'title', 'status'] }), getSellerHeaders()).then(
            response => {
                if (response.status === 200) {
                    this.setState({ salesList: response.data.data, tempSalesList: JSON.parse(JSON.stringify(response.data.data)), singleItemSalesList: JSON.parse(JSON.stringify(response.data.data)) });
                }
            }
        ).catch(error => {
            // toast.error(error.response.data['message']);
            if(error.response?.status == 401 || error.response?.status == 404) {
                this.setState({
                    errorPageRedirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
            this.setState({
                cloneProcess: false,
                cloneStatus: { show: true, type: 'danger', message: error?.response?.data['message'] instanceof Array ? error.response?.data['message'][0]['message'] : error?.response?.data['message'] }
            });

        });
    }

    /* Called when sales select */
    selectSale = (event) => {
        let value = Array.from(event.target.selectedOptions, option => option.value);
        this.cloneForm.sale = value;
        this.setState({ selectedSalesLength: value.length });
        this.enableButton();
    }

    /* Called when click optional items checkbox change */
    optionalItemDetails = (event, key) => {
        this.cloneForm[key] = event.target.checked;
    }

    /* Enable and disable clone button */
    enableButton = () => {
        const value = this.cloneForm.sale.length > 0 && (this.cloneForm.itemsList.length > 0 || this.cloneForm.singleItem.length > 0);
        this.setState({ enableCloneButton: value, enableGroupCloneButton: this.cloneForm.itemsList.length > 1 });
    }

    /* Called when click group cloning button */
    groupClone = (value) => {
        this.cloneModalConfig.header = 'Group Cloning';
        this.cloneModalConfig.label = this.cloneForm.itemsList.length;
        this.setState({ cloneModalConfig: this.cloneModalConfig, showCloneModal: true });
    }

    /* Called when table checkbox change */
    selectItems = (event, row) => {
        const index = this.state.itemsList.findIndex(x => x.id === row.id);
        if (index === -1) {
            this.state.itemsList.push(row);
            const salesIndex = this.state.salesList.findIndex(x => x.id === row.saleid);
            if (salesIndex > -1) {
                // this.state.salesList.splice(salesIndex, 1);
            }
            const addCheck = this.state.itemsList.length === this.state.tableData.data.length;
            this.setState({
                ...this.state,
                deleteItemids: this.state.itemsList
            }, () => {
                this.cloneForm.itemsList = this.state.itemsList;
                this.enableButton();
                this.checkBoxUpdate(addCheck);
            });
        } else {
            this.state.itemsList.splice(index, 1);
            const removeCheck = this.state.itemsList.length === this.state.tableData.data.length;
            const salesIndex = this.state.tempSalesList.findIndex(x => x.id === row.saleid);
            if (salesIndex > -1) {
                const notAll = this.state.itemsList.findIndex(x => x.saleid === this.state.tempSalesList[salesIndex].id);
                if (notAll === -1) {
                    this.state.salesList.push(this.state.tempSalesList[salesIndex]);
                }
            }
            this.setState({
                ...this.state,
                deleteItemids: this.state.itemsList
            }, () => {
                this.cloneForm.itemsList = this.state.itemsList;
                this.enableButton();
                this.checkBoxUpdate(removeCheck);
            });
        }
    }

    /* Return checked or not based on id for item checkbox */
    checkBoxChecked = (id) => {
        return this.cloneForm.itemsList.findIndex(x => x.id === id) > -1 || this.cloneForm.singleItem.findIndex(x => x.id === id) > -1;
    }

    /* Checkbox update */
    checkBoxUpdate = (value) => {
        this.dataTable.current.checkBoxHandle(value);
    }

    /* Called when table data update */
    updateTableData = (data) => {
        this.setState({
            ...this.state,
            tableData: data,
            salesList: JSON.parse(JSON.stringify(this.state.tempSalesList)),
            singleItemSalesList: JSON.parse(JSON.stringify(this.state.tempSalesList)),
            itemsList: [],
        });
        this.cloneForm.itemsList = [];
        this.enableButton();
        this.getNotesCount();
        this.checkBoxUpdate(false);
    }


    /* Called when table header checkbox change */
    allItemsSelect = (event) => {
        if (event) {
            this.setState({
                ...this.state,
                itemsList: JSON.parse(JSON.stringify(this.state.tableData.data)),
                deleteItemids: JSON.parse(JSON.stringify(this.state.tableData.data)),
            }, () => {
                this.state.itemsList.forEach(row => {
                    const salesIndex = this.state.salesList.findIndex(x => x.id === row.saleid);
                    // if (salesIndex > -1) {
                    //     this.state.salesList.splice(salesIndex, 1);
                    // }
                });
                this.enableButton();
            });
            this.cloneForm.itemsList = JSON.parse(JSON.stringify(this.state.tableData.data));
            this.checkBoxUpdate(true);
        } else {
            this.setState({
                ...this.state,
                itemsList: [],
                deleteItemids: [],
                salesList: JSON.parse(JSON.stringify(this.state.tempSalesList))
            }, () => {
                this.enableButton();
            });
            this.cloneForm.itemsList = [];
            this.checkBoxUpdate(false);
        }
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter'  && this.state.search.locationid.value && !this.state.errorMessage  && !this.state.locationErrorMsg) {
            this.enableSearch()
        }
    }
    navigateToList = () => {
        const state = this.props?.location?.state;
        if (this.props?.location?.state?.prevDatatable !== undefined) {
            this.props.location.state.datatable = this.props?.location?.state?.prevDatatable;
        }
        this.props.history.push({ pathname: '/sales', state: state });
    };

    /* set date for date input change */
    setDate = (control, date) => {
     
        this.setState((prevState) => ({
            issearch: true,
            locationErrorMsg: prevState.search.locationid.value ? "" : prevState.locationErrorMsg,
            search: {
                ...prevState.search,
                [control]: {
                    ...prevState.search[control],
                    value: date
                }
            }
        }), () => {
            let errorMessage = '';
            const { starttime, endtime } = this.state.search;
            let dateError = false
            if (control === "starttime" && starttime.value && endtime.value) {
                if (new Date(endtime.value) < new Date(starttime.value)) {
                    this.setState(prev => ({
                        search: {
                            ...prev.search,
                            endtime: {
                                ...prev.search.endtime,
                                value: null,
                            },
                        },
                    }));
                    return;
                }
            }
    
            if (starttime.value && endtime.value) {
                const start = new Date(starttime.value);
                const end = new Date(endtime.value);
    
          
                    const monthsDiff =
                        (end.getFullYear() - start.getFullYear()) * 12 +
                        (end.getMonth() - start.getMonth());
    
                    if (monthsDiff > 12 || (monthsDiff === 12 && end.getDate() > start.getDate()) || start > end) {
                        errorMessage = "Please select a date range within any 12 month period";
                        dateError = true
                    }
                
            }
    
            this.setState({ errorMessage, dateRangeError: dateError  });
        });

    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    /* Called when delete button confirmed */
    deleteItems = () => {
        this.setState({ deleteLoading: true });
        const itemslist = this.state.deleteItemids;
        const itemids = itemslist.map(x => x.id);

        const data = {
            "items": itemids,
        };
        axios.delete(getSellerUrl(itemdelete), { ...getSellerHeaders(), data: { 'data': data } })
            .then(
                response => {
                    if (response.status === 200) {
                        this.enableSearch();
                        if (response.data.data.items.length > 0) {
                            const responsedata = response.data.data.items;
                            const itemtitles = responsedata.map(x => x.title);
                            this.setState({
                                ...this.state,
                                deleteItemids: [],
                                deleteLoading: false,
                                deleteStatus: { show: true, type: 'danger', message: "The following item(s) can't be deleted :" + itemtitles }
                            });
                        }
                        else {
                            this.setState({
                                ...this.state,
                                deleteItemids: [],
                                deleteLoading: false,
                                deleteStatus: { show: true, type: 'success', message: "Item(s) have been deleted successfully" }
                            });
                        }
                    }
                })
            .catch(error => {
                this.setState({
                    ...this.state,
                    deleteLoading: false,
                    // deleteStatus: { show: true, type: 'danger', message: error.response.data.message }
                }
                );
            });
    }

    pageSizeChange = (event) => {
        const value = parseInt(event.target.value);
        this.setState({
            PageSize: value
        })
        this.dataTable?.current?.changeSize(value);
    }

    getNotesCount = () => {
        const itemsList = JSON.parse(JSON.stringify(this.state.tableData.data));
        const postData = itemsList.map(x => { return { id: x.id } });
        axios.post(getSellerUrl(itemsNoteCount), JSON.stringify({ data: postData }), getSellerHeaders()).then(res => {
            this.setState({
                notesCount: res.data.data
            });
        }).catch(error => error);
    }

    notesGreenCircle = (data) => {
        const count = this.state.notesCount.filter(x => x.ITEM_ID === data.id);
        return count.length > 0 ? count[0].INOT_Count > 0 : false;
    }

    render() {
        if (this.state.errorPageRedirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div className="item-list-main">
                <div className="item-search">
                    <div style={{ padding: '1% 5% 9px' }}>
                        <div className="item-list-search">
                            <Form className="w-100">
                                <Row className="d-flex flex-coloumn">
                                <Col>
                                    <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Select location</option>
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Category</label>
                                        <Form.Control as="select" name="categoryid"  onChange={(event) => this.searchInputChange(event)}>
                                            <option value="">All</option>
                                            {Object.keys(this.state.category).sort().map((category, index) =>
                                                <optgroup key={index} label={category} style={{ backgroundColor: "#efefef" }}>
                                                    {
                                                        this.state.category[category].length > 0 ?
                                                            this.state.category[category].map((subcategory, subIndex) =>
                                                                <option key={index + subIndex} value={subcategory} style={{ backgroundColor: "white" }}  selected={
                                                                    this.state.search.categoryGroup.value === category &&
                                                                    this.state.search.categoryid.value === subcategory
                                                                  } >{subcategory}</option>
                                                            ) :
                                                            <option key={index + 'no' + index} disabled style={{ backgroundColor: "white" }}>- - - - -</option>
                                                    }
                                                </optgroup>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Item Title</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="title" value={this.state.search.title.value} onChange={(event) => { this.searchInputChange(event) }} />
                                    </Col>
                                    <Col >
                                        <label>Description</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="description" value={this.state.search.description.value} onChange={(event) => { this.searchInputChange(event) }} />
                                    </Col>
                                    <Col >
                                        <label>Item SKU</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="SKU" value={this.state.search.SKU.value} onChange={(event) => { this.searchInputChange(event) }} />
                                    </Col>
                                    <Col>
                                        <label>Created Date From</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Created Date To</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                 
                                </Row>
                                <Row style={{ marginTop: '1%' }}>
                                    <Col >
                                        <label>Created By</label>
                                        <Form.Control as="select" name="createdby" value={this.state.search.createdby.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value='' disabled>Created by</option>
                                            {this.state.createdBy.map((created, index) =>
                                                <option key={index} value={created}>{created}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col >
                                        <label>Status</label>
                                        <Form.Control as="select" name="itemstatus" value={this.state.search.itemstatus.value} onChange={(event) => { this.searchInputChange(event) }} >
                                            <option value='' >All</option>
                                            <option value="Ready">Ready</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Sold">Sold</option>
                                            <option value="Not Sold">Not Sold</option>
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>State</label>
                                        <Form.Control as="select" name="state" value={this.state.search.state.value} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Select state</option>
                                            {
                                                this.state.stateList.map((state, idx) => <option key={idx} value={state['state']}>{state['state']}</option>)
                                            }
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>City</label>
                                        <Form.Control as="select" name="city" value={!this.state.search.state.value ? !this.state.search.city.value : this.state.search.city.value} disabled={!this.state.search.state.value} style={{ textTransform: "capitalize" }} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" selected>All</option>
                                            {this.state.cityList.map((city, index) =>
                                                <option key={index} value={city.city}>{city.city}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col >
                                        <label>Zip Code</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="zipcode" value={this.state.search.zipcode.value} onChange={(event) => { this.searchInputChange(event) }} />
                                    </Col>
                                    {this.state.search.saleid.value ? '' :
                                        <Col >
                                            <label>Sale Title</label>
                                            <Form.Control onKeyDown={this._handleKeyDown} type="text" name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => { this.searchInputChange(event) }} />
                                        </Col>
                                    }
                                    <Col></Col>
                                    {/* <Col >
                                        <label>Bought By</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="boughtby" value={this.state.search.boughtby.value} onChange={(event) => { this.searchInputChange(event) }} />
                                    </Col>
                                    {this.state.search.saleid.value ? <Col></Col> : ''} */}

                                </Row>
                                <Row className="buttonClass">
                            
                                    <Col className="d-flex justify-content-end align-items-center"  >
                                    {(this.state.errorMessage || this.state.locationErrorMsg)&& (
                                            <div className="text-danger text-center"  style={{fontSize: '14px'}}>
                                                {this.state.locationErrorMsg ? this.state.locationErrorMsg : this.state.errorMessage }
                                            </div>
                                        )}
                                    </Col>
                                    <Col md={5}>
                                        <div className="d-flex align-items-center justify-content-end" style={{ flexDirection: window.innerWidth < 450 ? 'column' : 'row' }}>
                                            <div className="mx-6 text-normal">Display Records Per Page</div>
                                            <div className="page-size-conatiner">
                                                <Form.Control as="select" onChange={this.pageSizeChange}>
                                                    { this.state.PageSize > 0 ? <option selected>{this.state.PageSize ? this.state.PageSize : 10 }</option> : null }
                                                    { this.state.PageSize !== 10 ? <option value={10}>10</option> : null }
                                                    { this.state.PageSize !== 25 ? <option value={25}>25</option>: null }
                                                    { this.state.PageSize !== 50 ? <option value={50}>50</option> : null }
                                                    { this.state.PageSize !== 100 ? <option value={100}>100</option> : null }
                                                    { this.state.PageSize !== 200 ? <option value={200}>200</option> : null }
                                                    { this.state.PageSize !== 400 ? <option value={400}>400</option> : null }
                                                    { this.state.PageSize !== 600 ? <option value={600}>600</option> : null }
                                                </Form.Control>
                                            </div>
                                            <Button className="mx-6" variant="secondary" disabled={this.state.deleteItemids.length === 0 && !this.state.enableGroupCloneButton} onClick={() => this.setState({ deleteModal: true, deleteStatus: { show: false, type: '', message: '' } })}>Delete</Button>

                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>

                                            <Button variant="seller-search" disabled={!this.state.search.locationid.value || this.state.errorMessage || this.state.locationErrorMsg} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                    {
                        this.props.match.params.saleId !== undefined && !isNaN(Number(this.props.match.params.saleId)) ?
                            <div className="d-flex">
                                <span className="clickable mr-2" style={{ alignSelf: 'flex-start', paddingLeft: '16px', paddingBottom: '8px' }} onClick={this.navigateToList}>
                                    <i className=" fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                                    <span style={{ paddingLeft: '8px' }}>Back</span>
                                </span>
                                - <span className="ml-2">{ this.props.location.state && this.props.location.state.saletitle ?  this.props.location.state.saletitle : this.state.Local_saletitle}</span>
                            </div> :
                            null
                    }
                </div>
                {this.state.modal ?
                    <Notes modal={this.state.modal} id={this.id} name='item' data={this.state.itemsDetails} hideNotes={this.hideNotes} getNotesCount={this.getNotesCount} /> : ''
                }
                <div className="item-list-table">
                    {/* need to add props, as it provides the previous state of datatable */}
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null}
                       ref={this.dataTable} onDataUpdate={this.updateTableData} allItemsSelect={this.allItemsSelect} onOpenAccordion={this.onOpenAccordion} showNotesGreenCircle></Datatable>
                </div>
                <Modal show={this.state.showCloneModal} onHide={() => this.setState({ ...this.state })} aria-labelledby="contained-modal-title-vcenter"
                    centered animation={false}>
                    <Modal.Header style={{ borderBottom: "none", marginBottom: "-7%" }}>
                        <p className="text-secondary text-bold">{this.state.cloneModalConfig.header}</p>
                        <Button type="button" onClick={this.closeCloneModal} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body>
                        {/* { this.state.cloneProcess ? 
                            <div className="d-flex flex-column align-items-center justify-content-center">
                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="default" height="100px" width="100px" />
                            </div> :  */}
                        <Form>
                            <Row>
                                <Col>
                                    <Form.Label className="cloneModalOpacity">Total Items Selected - {this.state.cloneModalConfig.label}</Form.Label>
                                    {
                                        this.state.singleItemLength > 0 ?
                                            <Form.Control as="select" custom className="mb-2" onChange={this.selectSale}>
                                                <option style={{ display: "none" }} >Select Sales &#42;</option>
                                                {this.state.singleItemSalesList.map((sale, index) =>
                                                    <option key={index} value={sale.id}>{sale.title}</option>
                                                )}
                                            </Form.Control> :
                                            <Form.Control as="select" custom className="mb-2" onChange={this.selectSale}>
                                                <option style={{ display: "none" }} >Select Sales &#42;</option>
                                                {this.state.salesList.map((sale, index) =>
                                                    <option key={index} value={sale.id}>{sale.title}</option>
                                                )}
                                            </Form.Control>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <fieldset className="mb-2">
                                        <legend>Optional Item Details</legend>
                                        <div key={`inline-checkbox`}>
                                            <Form.Check inline label="Media" type="checkbox" id={`inline-checkbox-1`} onChange={(event) => { this.optionalItemDetails(event, 'clonemedia') }} />
                                        </div>
                                    </fieldset>
                                </Col>
                            </Row>
                            <div className="mt-4">
                                <div className="d-flex flex-row justify-content-sm-center align-items-center">
                                    {
                                        this.state.cloneStatus.show ?
                                            <ToasterMessage type={this.state.cloneStatus.type} message={this.state.cloneStatus.message} className="alert-handle"></ToasterMessage>
                                            : null
                                    }
                                </div>
                                <Row className="justify-content-sm-center">
                                    <Col sm="auto" className="button-width-control">
                                        <Button variant="outline-primary" onClick={this.closeCloneModal}>Cancel</Button>
                                        <Button variant="secondary" disabled={this.state.cloneProcess || !this.state.enableCloneButton || this.state.cloneStatus.show } onClick={this.cloneCreate}>
                                            Clone {' '} {this.state.cloneProcess ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                            {/* {this.state.cloneProcess ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null} */}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                        {/* }     */}
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.deleteModal} size="md" animation={false} onHide={() => { this.setState({ deleteModal: false }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Would you like to delete these Item(s) ?
                            <div id="toaster" className={this.state.deleteStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} style={{ paddingTop: "3%" }} >
                                {
                                    this.state.deleteStatus.show ?
                                        <ToasterMessage type={this.state.deleteStatus.type} message={this.state.deleteStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => { this.setState({ deleteModal: false }) }}>Cancel</Button>
                                <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.deleteStatus.type === 'success' || this.state.deleteStatus.type === 'danger'} onClick={() => this.deleteItems()}>Confirm {this.state.deleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}